import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, InputNumber, Button, Tabs, notification, Switch } from 'antd';
import './BookingCategoryModal.css';

const { Text } = Typography;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'BookingCategoryStore',
)
@observer
class BookingCategoryModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
    }

    // ON CHANGE

    nameEnglishOnChange = (e) => {
        this.props.BookingCategoryStore.setNameEnglish(e.target.value);
    }

    nameChineseOnChange = (e) => {
        this.props.BookingCategoryStore.setNameChinese(e.target.value);
    }

    nameChineseTraditionalOnChange = (e) => {
        this.props.BookingCategoryStore.setNameChineseTraditional(e.target.value);
    }

    nameThaiOnChange = (e) => {
        this.props.BookingCategoryStore.setNameThai(e.target.value);
    }

    nameJapaneseOnChange = (e) => {
        this.props.BookingCategoryStore.setNameJapanese(e.target.value);
    }

    nameVietnameseOnChange = (e) => {
        this.props.BookingCategoryStore.setNameVietnamese(e.target.value);
    }

    descriptionEnglishOnChange = (e) => {
        this.props.BookingCategoryStore.setDescriptionEnglish(e.target.value);
    }

    descriptionChineseOnChange = (e) => {
        this.props.BookingCategoryStore.setDescriptionChinese(e.target.value);
    }

    descriptionChineseTraditionalOnChange = (e) => {
        this.props.BookingCategoryStore.setDescriptionChineseTraditional(e.target.value);
    }

    descriptionThaiOnChange = (e) => {
        this.props.BookingCategoryStore.setDescriptionThai(e.target.value);
    }

    descriptionJapaneseOnChange = (e) => {
        this.props.BookingCategoryStore.setDescriptionJapanese(e.target.value);
    }

    descriptionVietnameseOnChange = (e) => {
        this.props.BookingCategoryStore.setDescriptionVietnamese(e.target.value);
    }

    capacityOnChange = (value) => {
        this.props.BookingCategoryStore.setCapacity(value);
    }

    isAvailableOnChange = (value) => {
        this.props.BookingCategoryStore.setIsAvailable(value);
    }

    maxHourPerDayOnChange = (value) => {
        this.props.BookingCategoryStore.setMaxHourPerDay(value);
    }

    sortOrderOnChange = (value) => {
        this.props.BookingCategoryStore.setSortOrder(value);
    }

    // ON CLICK

    createOrUpdateBookingCategoryDetailOnClick = () => {
        this.props.BookingCategoryStore.createOrUpdateBookingCategoryDetail();
    }

    initUpdateBookingCategoryDetailOnClick = (bookingCategoryDetailId) => {
        this.props.BookingCategoryStore.initUpdateBookingCategoryDetail(bookingCategoryDetailId);
    }

    cancelBookingCategoryDetailOnClick = () => {
        this.props.BookingCategoryStore.cancelBookingCategoryDetail();
    }

    deleteBookingCategoryDetailOnClick = (bookingCategoryDetailId) => {
        this.props.BookingCategoryStore.deleteBookingCategoryDetail(bookingCategoryDetailId);
    }

    createOrUpdateBookingCategoryOnClick = () => {
        const { id } = this.props.BookingCategoryStore;
        if (id === 0) {
            this.props.BookingCategoryStore.createBookingCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: 'Success',
                        description: 'Booking  Category has been successfully created.',
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: 'Error',
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.BookingCategoryStore.updateBookingCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: 'Success',
                        description: 'Booking  Category has been successfully updated.',
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: 'Error',
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabNameOnTabClick = (key) => {
        this.props.BookingCategoryStore.setTabNameActiveKey(key);
    }

    tabDescriptionOnTabClick = (key) => {
        this.props.BookingCategoryStore.setTabDescriptionActiveKey(key);
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            tabNameActiveKey,
            tabDescriptionActiveKey,
            nameEnglish,
            nameChinese,
            nameChineseTraditional,
            nameThai,
            nameJapanese,
            nameVietnamese,
            descriptionEnglish,
            descriptionChinese,
            descriptionChineseTraditional,
            descriptionThai,
            descriptionJapanese,
            descriptionVietnamese,
            capacity,
            isAvailable,
            maxHourPerDay,
            sortOrder,
            itemTextButton,
            bookingCategoryModalLoading
        } = this.props.BookingCategoryStore;

        let addOrUpdateItemDisable = false;
        if (nameEnglish === '') {
            addOrUpdateItemDisable = true;
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Spin spinning={bookingCategoryModalLoading}>
                                <Row className='bookingcategorymodal-row-container'>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label-tabs'>
                                                <Text className='bookingcategorymodal-text-label'>Name<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <Tabs activeKey={tabNameActiveKey} onTabClick={this.tabNameOnTabClick}>
                                                    {/* English */}
                                                    {
                                                        this.isLanguageIdActive(1)
                                                            ?
                                                            <TabPane tab='English *' key='1'>
                                                                <Input className='bookingcategorymodal-input' value={nameEnglish} onChange={this.nameEnglishOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese */}
                                                    {
                                                        this.isLanguageIdActive(2)
                                                            ?
                                                            <TabPane tab='简体中文' key='2'>
                                                                <Input className='bookingcategorymodal-input' value={nameChinese} onChange={this.nameChineseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese Traditional */}
                                                    {
                                                        this.isLanguageIdActive(3)
                                                            ?
                                                            <TabPane tab='繁體中文' key='3'>
                                                                <Input className='bookingcategorymodal-input' value={nameChineseTraditional} onChange={this.nameChineseTraditionalOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Thai */}
                                                    {
                                                        this.isLanguageIdActive(4)
                                                            ?
                                                            <TabPane tab='ไทย' key='4'>
                                                                <Input className='bookingcategorymodal-input' value={nameThai} onChange={this.nameThaiOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Japanese */}
                                                    {
                                                        this.isLanguageIdActive(5)
                                                            ?
                                                            <TabPane tab='日本' key='5'>
                                                                <Input className='bookingcategorymodal-input' value={nameJapanese} onChange={this.nameJapaneseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Vietnamese */}
                                                    {
                                                        this.isLanguageIdActive(6)
                                                            ?
                                                            <TabPane tab='Vietnamese' key='6'>
                                                                <Input className='bookingcategorymodal-input' value={nameVietnamese} onChange={this.nameVietnameseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label-tabs'>
                                                <Text className='bookingcategorymodal-text-label'>Description<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <Tabs activeKey={tabDescriptionActiveKey} onTabClick={this.tabDescriptionOnTabClick}>
                                                    {/* English */}
                                                    {
                                                        this.isLanguageIdActive(1)
                                                            ?
                                                            <TabPane tab='English *' key='1'>
                                                                <Input className='bookingcategorymodal-input' value={descriptionEnglish} onChange={this.descriptionEnglishOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese */}
                                                    {
                                                        this.isLanguageIdActive(2)
                                                            ?
                                                            <TabPane tab='简体中文' key='2'>
                                                                <Input className='bookingcategorymodal-input' value={descriptionChinese} onChange={this.descriptionChineseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese Traditonal */}
                                                    {
                                                        this.isLanguageIdActive(3)
                                                            ?
                                                            <TabPane tab='繁體中文' key='3'>
                                                                <Input className='bookingcategorymodal-input' value={descriptionChineseTraditional} onChange={this.descriptionChineseTraditionalOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Thai */}
                                                    {
                                                        this.isLanguageIdActive(4)
                                                            ?
                                                            <TabPane tab='ไทย' key='4'>
                                                                <Input className='bookingcategorymodal-input' value={descriptionThai} onChange={this.descriptionThaiOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Jaoanese */}
                                                    {
                                                        this.isLanguageIdActive(5)
                                                            ?
                                                            <TabPane tab='日本' key='5'>
                                                                <Input className='bookingcategorymodal-input' value={descriptionJapanese} onChange={this.descriptionJapaneseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Vietnamese */}
                                                    {
                                                        this.isLanguageIdActive(6)
                                                            ?
                                                            <TabPane tab='Vietnamese' key='6'>
                                                                <Input className='bookingcategorymodal-input' value={descriptionVietnamese} onChange={this.descriptionVietnameseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>Capacity<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={1}
                                                    value={capacity}
                                                    onChange={this.capacityOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>Max Hour Per Day<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={maxHourPerDay}
                                                    onChange={this.maxHourPerDayOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>Sort Order<Text className='bookingcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={sortOrder}
                                                    onChange={this.sortOrderOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingcategorymodal-col-label'>
                                                <Text className='bookingcategorymodal-text-label'>Is Available</Text>
                                            </Col>
                                            <Col span={16} className='bookingcategorymodal-col-input'>
                                                <Switch checkedChildren='Yes' unCheckedChildren='No' checked={isAvailable} onChange={this.isAvailableOnChange} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingcategorymodal-col-button'>
                                        <Button disabled={addOrUpdateItemDisable} type='primary' className='bookingcategorymodal-button' onClick={this.createOrUpdateBookingCategoryOnClick}>{itemTextButton}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default BookingCategoryModalPage;
